import { gql } from '@common/hooks';
import { DetailItemAttachments } from '@onboarding/graphql/fragments';
import { FullValidationErrorFragment } from '@common/graphql/fragments';

const UpdateDocumentMutation = gql`
  mutation UpdateDocumentMutation(
    $id: ID!
    $input: UpdateDocumentInput!
    $files: [FileUploadInput!]!
    $aiTraceId: ID
  ) {
    updateDocument(
      id: $id
      input: $input
      files: $files
      aiTraceId: $aiTraceId
    ) {
      document {
        id
        detailItemAttachments {
          ...DetailItemAttachments
        }
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
  ${DetailItemAttachments}
`;

const CreateDocumentMutation = gql`
  mutation CreateDocumentMutation(
    $worksProfileId: ID!
    $worksListItemId: ID!
    $input: CreateDocumentInput!
    $files: [FileUploadInput!]!
    $aiTraceId: ID
  ) {
    createDocument(
      worksProfileId: $worksProfileId
      worksListItemId: $worksListItemId
      input: $input
      files: $files
      aiTraceId: $aiTraceId
    ) {
      document {
        id
        title
        detailItemAttachments {
          ...DetailItemAttachments
        }
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
  ${DetailItemAttachments}
`;

export { CreateDocumentMutation, UpdateDocumentMutation };
